/**   
 * api接口统一管理
 */
import { get, post , form_data } from './setting'

const user_api = {
    userinfo : '/api/user/info',
    queryplayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    score_info : '/api/user/score',//积分信息
    task_info : '/api/user/task/dict',//任务信息 a1 集签册好礼 c1 游戏内签到 m1 十二关地图胜利 j1 竞技/出征（击杀 助攻）10个 j2 新年首胜 g1 游戏内限时签到
    task_apply : '/api/user/task/receive',//任务领奖
    gacha_list : '/api/gift/shop',
    gacha_status : '/api/other/yd',
    gacha_apply : '/api/other/yd/claim',
    card_info : '/api/card/info',
    card_draw : '/api/draw/pool',
    card_record : '/api/card/record',
    card_share : '/api/card/share',
    share_info : '/api/card/share/info',
    share_apply : '/api/card/share/back',
}

export const apiUserInfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryplayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiScoreInfo = p => get(user_api.score_info, p);
export const apiTaskInfo = p => get(user_api.task_info, p);
export const apiTaskApply = p => post(user_api.task_apply, p);
export const apiGachaList = p => get(user_api.gacha_list, p);
export const apiGachaStatus = p => get(user_api.gacha_status, p);
export const apiGachaApply = p => post(user_api.gacha_apply, p);
export const apiCardInfo = p => get(user_api.card_info, p);
export const apiCardDraw = p => post(user_api.card_draw, p);
export const apiCardRecord = p => get(user_api.card_record, p);
export const apiCardShare = p => form_data(user_api.card_share, p);
export const apiShareInfo = p => get(user_api.share_info, p);
export const apiShareApply = p => form_data(user_api.share_apply, p);


